import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Vélez-Málaga"
      slug="velez-malaga"
      poblacion={82000}
      lat={36.7799}
      lng={-4.0998}
      neighborhoodsText="Cubrimos todo Vélez-Málaga, Torre del Mar y la Axarquía baja. Atendemos el casco histórico, Almayate, Caleta de Vélez y Mezquitilla con técnico propio."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Vélez-Málaga?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Vélez-Málaga?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}